export {};

declare global {
	interface Object {
		isEmpty(): boolean
		pick(): Object
		at(path: string, defaultValue?: any): any
		flatDeep(iterateFn?: (value: any, index?: number, array?: any[]) => any): any[]
		mergeDeep(...objects: Object[]): Object
		crc32(): number
	}
}

Object.defineProperty(Object.prototype, 'isEmpty', {
	enumerable: false,
    value: function() {
        return this && Object.keys(this).length === 0 && Object.getPrototypeOf(this) === Object.prototype
    }
})

Object.defineProperty(Object.prototype, 'pick', {
	enumerable: false,
    value: function(...by: string[]) {
        return Object.fromEntries(Object.entries(this).filter(([key]) => by.includes(key)))
    }
})

Object.defineProperty(Object.prototype, 'flatDeep', {
	enumerable: false,
    value: function(iterateFn?: (value: any, index?: number, array?: any[]) => any) {
        return Object.values(this).flatDeep(iterateFn)
    }
})

Object.defineProperty(Object.prototype, 'at', {
	enumerable: false,
    value: function(path: string, defaultValue?: any) {

        let object = this, parent, property;

        path.split(/[\.\[\]\'\"]/).filter(Boolean).each(path => {
            
            parent = object;
            
            if(object) {
                property = path;
                object = object[property];
            }
        });

		return {
			get: () => object ?? defaultValue ?? null,
			set: value => (parent && parent[property] ? parent[property] = value : null)
		}
    }
})

/**
* Performs a deep merge of objects and returns new object. Does not modify
* objects (immutable) and merges.
*
* @param {...object} objects - Objects to merge
* @returns {object} New object with merged key/values
*/
Object.defineProperty(Object.prototype, 'mergeDeep', {
	enumerable: false,
	value: function (...objects: Object[]) {

		const isObject = obj => typeof obj === 'object' && !Array.isArray(obj) && obj !== null;

		objects.unshift(this);

		return objects.reduce((prev, obj) => { 
			Object.keys(obj).forEach(key => {
				
				const pVal = prev[key];
				const oVal = obj[key];

				if(isObject(pVal) && isObject(oVal))
					prev[key] = pVal.mergeDeep(oVal);
				else
					prev[key] = oVal;
			});
		
			return prev;
		}, {});
	}
})


Object.defineProperty(Object.prototype, 'crc32', {
	enumerable: false,
	value: function () {
		return JSON.stringify(this).crc32();
	}
});
